import React from "react";
import s from './Users.module.scss'
import Paginator from "../../common/Paginator/Paginator";
import User from "./User";
import { getFollow, getUnFollow } from "../../redux/users-reducer";

const Users = ({ getUsersThunk, portionSize, currentPage, totalUsersCount, followingInProgress, pageSize, users }) => {

  return (
    <div className={s.users}>
      <Paginator getUsersThunk={getUsersThunk} portionSize={portionSize} currentPage={currentPage} totalUsersCount={totalUsersCount} pageSize={pageSize} />
      {
        users.map(u => <User
          key={u.id}
          user={u}
          followingInProgress={followingInProgress}
          getFollow={getFollow}
          getUnFollow={getUnFollow}
        />
        )
      }
    </div >
  );
}

export default Users;